@if (!hideWhenEmpty || pendingCount() > 0) {
  <tidy-card
    class="db-banner"
    [class.db-banner--active]="pendingCount() > 0"
    (click)="goToRequests()">
    <div class="db-banner__icon-tile">
      <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="db-banner__icon" />
    </div>

    <div class="db-banner__copy">
      <tidy-text [title]="'Inquiries'" class="db-banner__title" />
      @if (pendingCount() > 0) {
        <tidy-text
          class="db-banner__sub"
          [body]="pendingCount() === 1 ? '1 guest is waiting on your reply' : pendingCount() + (' guests are waiting on your reply' | translate)" />
      } @else {
        <tidy-text class="db-banner__sub" [body]="'Review and respond to guest inquiries here'" />
      }
    </div>

    @if (pendingCount() > 0) {
      <div class="db-banner__avatars">
        @for (initials of previewInitials(); track $index) {
          <span class="db-banner__avatar">{{ initials }}</span>
        }
        @if (pendingCount() > previewInitials().length) {
          <span class="db-banner__avatar db-banner__avatar--more">
            +{{ pendingCount() - previewInitials().length }}
          </span>
        }
      </div>
    }

    <div class="db-banner__cta">
      <span class="db-banner__cta-label">Review</span>
      <tidy-image [src]="'assets/svg/chevron-forward.svg'" class="db-banner__cta-chevron" />
    </div>
  </tidy-card>
}
